module.exports = __webpack_public_path__ + "static/img/hangup.39b383c2.png";